module.exports = new __parcel__URL__("chevron-right.93d437c0.svg").toString();